import { AgentsAiDetectorIcon, Icon, type IconProps } from '@grammarly/design-system'

type AiDetectorAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const AiDetectorAgentIcon = ({ size, accessibilityLabel }: AiDetectorAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsAiDetectorIcon}
      accessibilityLabel={accessibilityLabel ?? 'AI Detector'}
    />
  )
}
